import { apiClient } from './client'
import { ApiError } from './errors'

export interface AutoInvest {
  id: number
  amount: number
  duration?: string
  productId: number
  vaultId: number
  investBy?: string
  active: boolean
}

export async function fetchAutoInvests(): Promise<AutoInvest[]> {
  try {
    const response = await apiClient.get<AutoInvest[]>('auto_invest')
    return response.data
  } catch (err) {
    throw ApiError.fromAxiosError(err)
  }
}

export async function createAutoInvest(data: {
  productId: number
  vaultId: number
  amount: number
  duration?: string
  investBy: string
}): Promise<AutoInvest> {
  try {
    const response = await apiClient.post<AutoInvest>('auto_invest', {
      product_id: data.productId,
      vault_id: data.vaultId,
      amount: data.amount,
      invest_by: data.investBy,
      ...(data.duration ? { duration: data.duration } : {})
    })
    return response.data
  } catch (err) {
    throw ApiError.fromAxiosError(err)
  }
}

export async function deleteAutoInvest(id: number): Promise<void> {
  try {
    await apiClient.delete(`auto_invest/${id}`)
  } catch (err) {
    throw ApiError.fromAxiosError(err)
  }
}
